/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'heart-circle': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 2C6.47 2 2 6.5 2 12a10 10 0 0010 10 10 10 0 0010-10A10 10 0 0012 2M9.75 7.82c.87 0 1.7.41 2.25 1.05.55-.64 1.38-1.05 2.25-1.05 1.54 0 2.75 1.21 2.75 2.75 0 1.89-1.7 3.43-4.28 5.77L12 17l-.72-.66C8.7 14 7 12.46 7 10.57c0-1.54 1.21-2.75 2.75-2.75z"/>'
  }
})
